import styled from 'styled-components';

import { media } from '../../../styles/breakpoints';

export const LoginCard = styled.div`
  width: 100%;
  max-width: 380px;
  text-align: center;

  ${media.sm} {
    max-width: 100%;
    padding: 0 4px;
  }
`;

export const LoginSubtitle = styled.p`
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
  margin: 0 0 32px 0;

  ${media.sm} {
    margin: 0 0 24px 0;
  }
`;

export const FormWrapper = styled.div`
  text-align: left;

  .ant-form-item {
    margin-bottom: 20px;

    ${media.sm} {
      margin-bottom: 16px;
    }
  }

  .ant-form-item-label {
    padding-bottom: 4px;

    label {
      font-size: 14px;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
    }
  }

  .ant-input-affix-wrapper,
  .ant-input {
    height: 48px;
    border-radius: 8px;
    border-color: #e8e8e8;
    font-size: 16px;

    &:hover,
    &:focus {
      border-color: var(--primary);
    }

    ${media.sm} {
      height: 50px;
    }
  }

  .ant-input-affix-wrapper {
    padding: 0 12px;

    .ant-input {
      height: auto;
      font-size: 16px;
    }
  }

  .ant-input-prefix {
    margin-right: 10px;
    color: rgba(0, 0, 0, 0.25);

    svg {
      font-size: 18px;
    }
  }
`;

export const RememberRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;

  ${media.sm} {
    margin-bottom: 20px;
  }

  .ant-checkbox-wrapper {
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
  }

  a {
    color: var(--primary);
    font-size: 14px;
    font-weight: 500;

    &:hover {
      opacity: 0.8;
    }
  }
`;

export const SubmitButton = styled.button`
  width: 100%;
  height: 50px;
  background: var(--primary);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    opacity: 0.9;
  }

  &:active {
    transform: scale(0.98);
    background: var(--primary);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  svg {
    font-size: 18px;
  }

  ${media.sm} {
    height: 52px;
    font-size: 17px;
  }
`;

export const CompanySelectWrapper = styled.div`
  width: 100%;
  max-width: 400px;
  text-align: center;

  ${media.sm} {
    max-width: 100%;
    padding: 0 4px;
  }
`;

export const CompanySelectTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  margin: 0 0 8px 0;
`;

export const CompanySelectSubtitle = styled.p`
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
  margin: 0 0 24px 0;
`;

export const CompanyList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 350px;
  overflow-y: auto;
  padding: 4px;
  margin-bottom: 16px;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 3px;
  }

  ${media.sm} {
    max-height: 55vh;
    gap: 8px;
  }
`;

export const CompanyCard = styled.button`
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  padding: 16px;
  background: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s;
  text-align: left;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    background: #f0f0f0;
    border-color: var(--primary);
    transform: translateX(4px);
  }

  &:active {
    background: #f0f0f0;
    border-color: var(--primary);
    transform: scale(0.98);
  }

  ${media.sm} {
    padding: 14px;
    gap: 12px;
    border-radius: 12px;
  }
`;

export const CompanyIcon = styled.div`
  width: 44px;
  height: 44px;
  background: linear-gradient(135deg, rgba(138, 43, 226, 0.1) 0%, rgba(75, 0, 130, 0.15) 100%);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    font-size: 20px;
    color: var(--primary);
  }

  ${media.sm} {
    width: 40px;
    height: 40px;

    svg {
      font-size: 18px;
    }
  }
`;

export const CompanyInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const CompanyName = styled.div`
  font-size: 15px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  line-height: 1.4;
  text-transform: capitalize;
  word-break: break-word;

  ${media.sm} {
    font-size: 14px;
  }
`;

export const CompanyArrow = styled.div`
  color: rgba(0, 0, 0, 0.25);
  transition: all 0.2s;

  svg {
    font-size: 18px;
  }

  ${CompanyCard}:hover & {
    color: var(--primary);
    transform: translateX(4px);
  }
`;

export const BackButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: none;
  background: transparent;
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
  cursor: pointer;
  padding: 12px 20px;
  border-radius: 6px;
  transition: all 0.2s;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    color: var(--primary);
    background: rgba(138, 43, 226, 0.05);
  }

  &:active {
    color: var(--primary);
    background: rgba(138, 43, 226, 0.08);
  }

  svg {
    font-size: 16px;
  }

  ${media.sm} {
    padding: 14px 24px;
    font-size: 15px;
  }
`;

export const CodigoWrapper = styled.div`
  .ant-input {
    height: 56px;
    text-align: center;
    font-size: 26px;
    letter-spacing: 12px;
    font-variant-numeric: tabular-nums;
  }
`;

export const CodigoErro = styled.p`
  margin: 8px 0 0;
  font-size: 13px;
  color: #f5222d;
`;

export const CodigoAjuda = styled.p`
  margin: 8px 0 0;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.45);
  text-align: center;
`;

export const CodigoReenvio = styled.div`
  margin-top: 16px;
  text-align: center;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.35);

  button {
    border: none;
    background: transparent;
    color: var(--primary);
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    padding: 0;
  }
`;
